import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IDishNameField {
	changeDishName: (value: string) => void;
}

const DishNameField: React.FC<IDishNameField> = ({ changeDishName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterDishName') }], [t]);

	return (
		<FormInput
			testId="DishNameField"
			name="name"
			label="nameLabel"
			onChange={changeDishName}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
};

export default React.memo(DishNameField);
